import { render, staticRenderFns } from "./NewsBoardDetails.vue?vue&type=template&id=0b200441&"
import script from "./NewsBoardDetails.vue?vue&type=script&lang=ts&"
export * from "./NewsBoardDetails.vue?vue&type=script&lang=ts&"
import style0 from "./NewsBoardDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports